import { FlaskConical } from "lucide-react";

/** Every surface that identifies Proof renders this glyph, never a lucide icon of its own. */
export const ProofIcon = FlaskConical;
